<template>
    <header class="navbar">
        <div class="container navbar-content">
            <!-- Logo/Home Link -->
            <router-link to="/" class="logo">KC-Afrobraids</router-link>

            <!-- Desktop Navigation Links -->
            <nav class="nav-links">
                <router-link :to="{name: 'gallery'}">GALLERY</router-link>
                <router-link :to="{name: 'location'}">LOCATION</router-link>
                <router-link :to="{name: 'testimonial'}">TESTIMONIAL</router-link>
                <router-link to="/about">ABOUT US</router-link>

                <!-- Book Button -->
                <router-link :to="{name: 'services'}" class="book-button">BOOK NOW</router-link>
            </nav>

            <!-- Mobile Menu Toggle Button -->
            <button class="menu-toggle" @click="toggleMenu" aria-label="Toggle Menu">
                <!-- Use an icon or hamburger character -->
                {{ isMobileMenuOpen ? '✕' : '☰' }}
            </button>
        </div>

        <!-- Mobile Menu: v-show handles visibility -->
        <nav class="mobile-menu" v-show="isMobileMenuOpen">
            <!-- Links for mobile menu -->
            <router-link :to="{name: 'services'}" @click="closeMenu">BOOK NOW</router-link>
            <router-link to="/gallery" @click="closeMenu">GALLERY</router-link>
            <router-link :to="{name: 'location'}" @click="closeMenu">LOCATION</router-link>
            <router-link :to="{name: 'testimonial'}" @click="closeMenu">TESTIMONIAL</router-link>
            <router-link to="/about" @click="closeMenu">ABOUT US</router-link>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'NavigationBarTop',
    data() {
        return {
            isMobileMenuOpen: false
        }
    },
    methods: {
        toggleMenu() {
            // Toggles the state which controls v-show
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },
        closeMenu() {
            // Helper to close the menu after a link is clicked
            this.isMobileMenuOpen = false;
        }
    }
}
</script>

<style scoped>
    a {
        text-decoration: none;
        color: inherit;
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1rem;
    }

    /* 1. Navbar Styling */
    .navbar {
        background-color: #1c1917;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5); /* Stronger shadow for depth */
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .navbar-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* Adjusted padding to match 70px height from previous version */
        height: 70px; 
    }
    
    /* Ensure desktop nav links are light colored */
    .nav-links {
        color: #f5f5f4;
        display: none; /* Hidden by default for mobile */
        align-items: center;
        gap: 1.5rem;
    }

    header .logo {
        font-size: 1.875rem; /* text-3xl */
        font-family: var(--font-serif);
        font-weight: 800; /* extrabold */
        color: #FBBF24;
        letter-spacing: 0.05em;
    }

    .nav-links a {
        padding: 0.5rem 1rem;
        transition: color 0.3s;
        font-weight: 500;
        font-size: 0.95rem;
        color: #f5f5f4; /* Explicitly set link color */
    }

    .nav-links a:hover,
    .nav-links a.router-link-exact-active {
        color: #FBBF24; /* Gold hover/active */
    }

    .nav-links .book-button {
        background-color: #5D0E1F; /* Maroon */
        color: white !important;
        padding: 0.5rem 1rem;
        border-radius: 20px;
        margin-left: 1rem;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
        border: none;
    }

    .nav-links .book-button:hover {
        background-color: #5d280e; /* Sienna/Earth tone hover */
        transform: scale(1.05);
    }

    .menu-toggle {
        display: block; /* Visible on mobile */
        font-size: 1.5rem;
        cursor: pointer;
        border: none;
        background: none;
        color: #FBBF24; /* Gold toggle icon */
    }

    .mobile-menu {
        
        display: flex; 
        flex-direction: column;
        background-color: #1c1917;
        position: absolute; /* Ensures it sits below the header */
        width: 100%;
        left: 0;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        text-align: center;
        padding-bottom: 0.5rem;
        box-shadow: 0 8px 10px rgba(0, 0, 0, 0.4);
    }
    
    .mobile-menu a {
        display: block;
        padding: 0.75rem 1rem;
        color: #f5f5f4; /* Light text on dark background */
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    }
    
    .mobile-menu a:hover {
        background-color: #5D0E1F; /* Maroon hover background */
        color: white;
    }
    
    /* Mobile Book Button Styling */
    .mobile-menu .book-button {
        background-color: #5D0E1F;
        color: white !important;
        margin: 10px 1rem;
        border-radius: 20px;
    }
    /* --- Desktop Styles (Hides Mobile elements) --- */
    @media (min-width: 900px) { /* Changed from 768px to 900px for consistency */
        /* 1. Navbar */
        .nav-links {
            display: flex; /* Show desktop links */
            align-items: center;
            gap: 1.5rem;
        }
        
        .menu-toggle {
            display: none; /* Hide toggle button */
        }

        .mobile-menu {
            display: none !important; 
        }
    }

</style>